module.exports = __webpack_public_path__ + "static/media/YM22_2.7cd85508.jpg";